export var EField;
(function (EField) {
    EField["Header"] = "_header";
    EField["Provider"] = "provider";
    EField["StartDate"] = "startDate";
    EField["Amount"] = "amount";
    EField["Info"] = "info";
    EField["DueDate"] = "dueDate";
    EField["Signers"] = "signers";
    EField["Payer"] = "payer";
    EField["Broker"] = "broker";
    EField["DocumentType"] = "documentType";
    EField["IdentityDocuments"] = "identityDocuments";
    EField["IdentityDocumentAccountId"] = "accountId";
    EField["IdentityDocumentIdentityFrontDocumentId"] = "identityFrontDocument";
    EField["IdentityDocumentIdentityBackDocumentId"] = "identityBackDocument";
    EField["LegalContactInfo"] = "legalContactInfo";
    EField["SignAsBroker"] = "signAsBroker";
    EField["Locale"] = "locale";
    EField["DateOfExpiry"] = "dateOfExpiry";
    EField["InsuranceSendProposal"] = "insuranceSendProposal";
    EField["InsuranceDataSharing"] = "insuranceDataSharing";
    EField["InsuranceContractRentPrice"] = "insuranceContractRentPrice";
    EField["InsuranceBuildingSurfaceArea"] = "insuranceBuildingSurfaceArea";
    EField["InsuranceBuildingLayers"] = "insuranceBuildingLayers";
    EField["InsuranceBuildingAdjoined"] = "insuranceBuildingAdjoined";
    EField["InsuranceBuildingHasHardMaterials"] = "insuranceBuildingHasHardMaterials";
})(EField || (EField = {}));
export var EBanqupRentioDocumentType;
(function (EBanqupRentioDocumentType) {
    EBanqupRentioDocumentType["IdCard"] = "ID_CARD";
    EBanqupRentioDocumentType["Passport"] = "PASSPORT";
})(EBanqupRentioDocumentType || (EBanqupRentioDocumentType = {}));
